// Route: /courses/$courseId/topics/$topicId — воркспейс курса с открытой темой.
//
// NON-NESTED намеренно (декрет E9): `routes/courses/$courseId.tsx` рендерит
// свой контент БЕЗ <Outlet/>, поэтому вложенный child молча не отрисовался бы
// (rules/code-quality §35). Путь в `createFileRoute` — с подчёркиванием,
// ссылки (`<Link to>`) — без него; единая точка каста — `topicLinkProps`
// (`components/courses/_api.ts`), её менять нельзя.
//
// Оба роута рендерят ОДИН компонент
// `components/courses/workspace/course-workspace.tsx` — отличие только в том,
// пришла ли тема из URL.
//
// URL state — общая схема обоих роутов (`workspace/_search.ts`, декрет E11):
// ?view= · ?fmt= · ?note= · ?edit=1 · ?demo= · ?read= (@deprecated → view=note).
//
// `NativeTransition` — переход между ТЕМАМИ (§7.4: «сохранить»). Он жил на этом
// роуте до выноса воркспейса и потерялся при переезде; ключ — `topicId`, поэтому
// смена вида сцены (`?view=`) анимацию НЕ запускает, а переход на другую тему —
// запускает. Fade+scale (не slide) намеренно: slide конфликтует с
// edge-swipe-back на iOS.

import { tolerantSearch } from "@studyhub/shared/utils/tolerant-search";
import { NativeTransition } from "@studyhub/ui/components/native-transition";
import { createFileRoute } from "@tanstack/react-router";
import { courseWorkspaceSearchSchema } from "@/components/courses/workspace/_search";
import {
	CourseWorkspace,
	CourseWorkspacePending,
} from "@/components/courses/workspace/course-workspace";
import { useArtifactWatching } from "@/hooks/use-artifact-watching";
import { markArtifactSeenKey } from "@/hooks/use-mark-artifact-seen";

export const Route = createFileRoute("/courses/$courseId_/topics/$topicId")({
	validateSearch: tolerantSearch(courseWorkspaceSearchSchema),
	component: TopicPage,
	pendingComponent: CourseWorkspacePending,
});

function TopicPage(): React.ReactElement {
	const { courseId, topicId } = Route.useParams();
	const search = Route.useSearch();
	// «Я смотрю на эту тему» — гасит push/уведомления о её готовности, пока
	// экран открыт. Живёт на роуте, а не в каркасе: на `/courses/$courseId`
	// пользователь темy ещё не открыл.
	useArtifactWatching(markArtifactSeenKey("study-plan", topicId));

	return (
		<NativeTransition transitionKey={topicId}>
			<CourseWorkspace courseId={courseId} routeTopicId={topicId} search={search} />
		</NativeTransition>
	);
}
